import { render, staticRenderFns } from "./LabelSelector.vue?vue&type=template&id=0578c7fa&scoped=true"
import script from "./LabelSelector.vue?vue&type=script&lang=ts"
export * from "./LabelSelector.vue?vue&type=script&lang=ts"
import style0 from "./LabelSelector.vue?vue&type=style&index=0&id=0578c7fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0578c7fa",
  null
  
)

export default component.exports